import {Spinner} from '@primer/react'
import {clsx} from 'clsx'

import {TEST_IDS} from '../../constants/test-ids'
import styles from './TimelineDivider.module.css'

type TimelineDividerProps = {
  isLoading?: boolean
  isHovered?: boolean
  id?: string
}

export const TimelineDivider = ({isLoading, isHovered, id}: TimelineDividerProps) => (
  <div
    data-testid={id ? TEST_IDS.timelineDivider(id) : undefined}
    className={clsx(styles.Box, isLoading && styles.BoxLoading)}
  >
    {isLoading ? (
      <Spinner size={'small'} />
    ) : (
      <>
        <div className={styles.Box_1} />
        <div className={clsx(styles.Box_2, isHovered && styles.Box_2Hovered)} />
      </>
    )}
  </div>
)
